// removed by extract-text-webpack-plugin
module.exports = {"button":"_1UxwGP-N0os-cghzcIVUR6","after":"_2edFfsNfS1mQhB-28_sLRJ"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/FlatButton/FlatButton.css
// module id = 1052
// module chunks = 58